module.exports = __webpack_public_path__ + "img/accommodation-dashboard-icon.103083b.png";